<script setup lang="ts">
import {ref} from 'vue'
import '@/assets/styles/contact.css'
import axios from 'axios'

const name = ref('')
const email = ref('')
const message = ref('')
const submitted = ref(false)
const error = ref('')
const showToast = ref(false);
const toastMessage = ref("");
const showConfirmToast = ref(false);

const form = ref({
  name: '',
  email: '',
  message: '',
  data: false
})

const submitForm = async () => {

  submitted.value = false
  error.value = ''

  try {
    const res = await axios.post("/api/contact", {
      name: form.value.name,
      email: form.value.email,
      message: form.value.message
    })
    submitted.value = true
    form.value = {name: "", email: "", message: "", data: false}

    console.log("Antwort: ", res.data);
  } catch (err) {
    error.value = 'Fehler beim Versenden';
    console.error(err);
  }
};

const abfrage = () => {
  showConfirmToast.value = true;
}

const confirmSubmission = async () => {
  submitForm();

  toastMessage.value = "Ihre Kontaktanfrage wurde übermittelt.";
  showToast.value = true;

  setTimeout(() => showToast.value = false, 4000);
  showConfirmToast.value = false;
}

const cancelSubmission = async () => {
  showConfirmToast.value = false
}
</script>

<template>
  <div class="contact-container">
    <div v-if="showToast" class="toast">
      {{ toastMessage }}
    </div>

    <div v-if="showConfirmToast" class="confirm-toast-overlay">
      <div class="confirm-toast-box">
        <div class="confirm-icon">K</div>
        <p class="confirm-eyebrow">Kontaktanfrage senden</p>
        <h2>Anfrage abschicken?</h2>
        <p class="confirm-copy">
          Ihre Nachricht wird an KFZ Musterwerkstatt übermittelt. Wir melden uns schnellstmöglich bei Ihnen zurück.
        </p>
        <div class="confirm-toast-buttons">
          <button class="cancel-btn" type="button" @click="cancelSubmission">Abbrechen</button>
          <button class="confirm-btn" type="button" @click="confirmSubmission">Anfrage senden</button>
        </div>
      </div>
    </div>

    <div class="card-contact">
      <h1>Kontakt</h1>
      <p>Schreiben Sie uns direkt. Wir melden uns schnellstmöglich mit einer persönlichen Rückmeldung.</p>

      <form @submit.prevent="abfrage" class="contact-form">
        <label>
          Name:
          <input type="text" v-model="form.name" placeholder="Dein Name" required/>
        </label>

        <label>
          E-Mail:
          <input type="email" v-model="form.email" placeholder="Deine E-Mail" required/>
        </label>

        <label>
          Nachricht:
          <textarea v-model="form.message" placeholder="Deine Nachricht" required></textarea>
        </label>

        <label class="checkbox-label">
          <span class="checkbox-text">
              Ich stimme der Verarbeitung meiner Daten gemäß
              <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>
              zu.
              </span>
          <input
              type="checkbox"
              v-model="form.data"
              required
          />
          <span class="custom-checkbox"></span>
        </label>

        <button type="submit">Absenden</button>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>
